import { startCase } from 'lodash-es';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import {
  Container,
  ContainerContent,
  GoBack,
  ModelTrainingPageContent,
} from '@/component';
import { VFlex } from '@/package';
import { useMainLayout } from '@/provider';
import { ModelTrainingFormContextProvider } from '@/provider';

const ModelTrainingPage = () => {
  const { setTitle } = useMainLayout();
  const { t } = useTranslation();

  useEffect(() => {
    setTitle(() => (
      <VFlex className="gap-[10px]" items="center">
        <GoBack to={`/modeling`} />
        {startCase(t('modeling.modelTraining.moksha'))}
      </VFlex>
    ));
  }, []);

  return (
    <ModelTrainingFormContextProvider>
      <Container>
        <ContainerContent>
          <ModelTrainingPageContent />
        </ContainerContent>
      </Container>
    </ModelTrainingFormContextProvider>
  );
};

export default ModelTrainingPage;
